import { Column, Columns, Container } from '@codeparva/ui-components-library';
import React from 'react';
import { CallToActionButton } from '../../../../components/ctaButton/CTAButton';
import { Row } from '../../../../components/row/Row';
import { CTASectionTypes } from './CtaSectionTypes';

export const CtaSection = ({
  title,
  description,
  callToAction,
  variant,
  theme = 'light',
}: CTASectionTypes.ICTASection) => {
  const titleColor = theme === 'light' ? 'text-color-primary' : 'secondary';
  const sectionBackgroundColor = theme === 'light' ? 'secondary' : 'primary';

  const ShowTitle = () => {
    return title ? (
      <div className="is-flex">
        <span className={`ctaSectionHeading`}></span>
        <div className={`has-text-${titleColor}`}>
          <h3>{title}</h3>
        </div>
      </div>
    ) : (
      <></>
    );
  };

  const ShowCtaActionButton = () => {
    return callToAction && callToAction.show ? (
      <Row
        className={`my-2 ${
          variant === 'CTASectionWithTitleDescription'
            ? 'alignCTAItems'
            : 'pt-5 is-justify-content-left'
        }`}
      >
        <CallToActionButton {...callToAction} />
      </Row>
    ) : (
      <></>
    );
  };

  const CTASectionWithTitle = () => {
    return (
      <Row className="is-justify-content-center is-width-100">
        <Columns className="is-left m-0">
          <Column className="p-0">
            <ShowTitle />
            <p
              className={`has-text-${titleColor} descriptionText mt-2 py-5 has-text-left`}
            >
              {description}
            </p>
            <ShowCtaActionButton />
          </Column>
        </Columns>
      </Row>
    );
  };

  const CTASectionWithOnlyTitle = () => {
    return (
      <Row className="is-justify-content-center is-width-100">
        <Columns centered className="is-width-100 m-0">
          <Column textAlign="left">
            <ShowTitle />
            <ShowCtaActionButton />
          </Column>
        </Columns>
      </Row>
    );
  };

  const CTASectionWithOnlyDescription = () => {
    return (
      <Row className="is-justify-content-center is-width-100">
        <Columns className="is-left m-0">
          <Column textAlign="left">
            <p
              className={`has-text-${titleColor} descriptionText has-text-left px-2`}
            >
              {description}
            </p>
            <ShowCtaActionButton />
          </Column>
        </Columns>
      </Row>
    );
  };

  const DisplayVariant = () => {
    switch (variant) {
      case 'CTASectionWithTitleDescription':
        return <CTASectionWithTitle />;
      case 'CTASectionWithTitleOnly':
        return <CTASectionWithOnlyTitle />;
      default:
        return <CTASectionWithOnlyDescription />;
    }
  };

  return (
    <div
      className={`ctaSectionContainer has-background-${sectionBackgroundColor}`}
    >
      <Container>
        <DisplayVariant />
      </Container>
    </div>
  );
};
